import { COMMON_SET_LOADING, COMMON_SET_DATA, COMMON_SET_ERROR, COMMON_INIT_DATA } from './actions'

var setData = (state, key, data) => {
    
    state[key] = { data }
    return Object.assign({}, state);
}

var setError = (state, key, error) => {
    state[key] = { error };
    return Object.assign({}, state);
}

var setLoading = (state, key, isLoading) => {
    state[key] = { isLoading };
    return Object.assign({}, state);
}

var initData = (state, key, data) => {
    state[key] = { ...data };
    return Object.assign({}, state);
}

var initState = {
}
export function CreateService(state = initState, action) {
    switch (action.type) {
        case COMMON_SET_DATA:
            return setData(state, action.key, action.data);
        case COMMON_SET_ERROR:
            return setError(state, action.key, action.error);
        case COMMON_SET_LOADING:
            return setLoading(state, action.key, action.isLoading);
        case COMMON_INIT_DATA:
            return initData(state, action.key, action.data);
        default:
            break;
    }
    return state;
};
export default CreateService;


// WEBPACK FOOTER //
// ./_source/cqsx/services/create-service/reducers.js